import React from "react";
import { useMarket } from "../../context/MarketContext";
import { meta, fmtPrice } from "../../lib/symbols";
import Sparkline from "./Sparkline";
import { Plus } from "lucide-react";

export const STRIP = ["1HZ10V", "1HZ25V", "1HZ75V", "1HZ100V", "cryBTCUSD", "frxEURUSD"];

export default function QuoteStrip({ onSelect }) {
  const { quotes } = useMarket();

  return (
    <div className="flex items-center gap-2.5 overflow-x-auto scrollbar-thin pb-1" data-testid="quote-strip">
      {STRIP.map((code) => {
        const m = meta(code);
        const q = quotes[code];
        const up = (q?.changePct ?? 0) >= 0;
        return (
          <button
            key={code}
            data-testid={`quote-card-${code}`}
            onClick={() => onSelect(code)}
            className="flex items-center gap-3 shrink-0 px-3 py-2 rounded-xl bg-panel border border-border hover:border-primary/60 transition-colors min-w-[170px]"
          >
            <div className="text-left">
              <div className="text-xs font-semibold">{m.display}</div>
              <div className="text-sm font-mono-nums">{q ? fmtPrice(q.price, m.decimals) : "—"}</div>
            </div>
            <Sparkline data={q?.history || []} up={up} />
            <div className={`text-[11px] font-mono-nums ${up ? "text-buy" : "text-sell"}`}>
              {up ? "▲" : "▼"}{Math.abs(q?.changePct ?? 0).toFixed(2)}%
            </div>
          </button>
        );
      })}
      <button data-testid="add-symbol-btn" className="flex items-center gap-2 shrink-0 px-4 py-2 rounded-xl border border-dashed border-border text-muted-foreground hover:text-foreground hover:border-primary/60 text-xs">
        <Plus className="h-4 w-4" /> Add Symbol
      </button>
    </div>
  );
}
